import runSsrSafely from '@utils/ssr/runSsrSafely';
import fetchTransactionDesigner from '@utils/ssr/fetchTransactionDesigner';

export default function ssrFetch(ctx) {
    const options = ctx.timeout ? {timeout: ctx.timeout} : {};
    return runSsrSafely(fetchTransactionDesigner({...ctx, options}));
}
